import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../../shared/models/component-messages/mapaRE/step1';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { FNSimple } from '../../../common/models/FNSimple';
import { Rectificatif } from '../../models/Rectificatif';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {

  @Input() rectificatif: Rectificatif;
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;


	@Input() uid = '';
  @Input() linkForRouter: string;
  public step1 = new Step1();

	constructor() { }


  ngOnInit(): void {
  }

  public getUid() {
		return this.uid;
	}

}
